export function getDuration(date: Date, endDate?: Date): string {
  const date2 = endDate ?? new Date();
  const duration = date2.getTime() - date.getTime();
  const days = Math.floor(duration / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);
  let result = "";
  if (years > 0) {
    result += `${years} yr${years > 1 ? "s" : ""} `;
  }
  if (months % 12 > 0) {
    result += `${months % 12} mo${months % 12 > 1 ? "s" : ""}`;
  }
  return result.trim();
}